import { Popover, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { StyledCheckbox } from '../../utils/commonStyles.Styled';
import { StyledListItemText } from '../filters/FilterDropDown.Styled';

interface TableFilterDropdownProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  columnId: string | null;
  values: string[];
  selectedValues: string[];
  onFilterChange: (columnId: string, value: string, isChecked: boolean) => void;
}

export const TableFilterDropdown: React.FC<TableFilterDropdownProps> = ({
  anchorEl,
  open,
  onClose,
  columnId,
  values,
  selectedValues,
  onFilterChange,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          width: '190px',
          maxHeight: '250px',
          minHeight: '250px',
          overflowY: 'auto',
          padding: '10px',
        },
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {values.map((value) => (
          <FormControlLabel
            key={value}
            sx={{
              whiteSpace: 'nowrap',
            }}
            control={
              <StyledCheckbox
                checked={selectedValues.includes(value)}
                onChange={(e) => onFilterChange(columnId, value, e.target.checked)}
              />
            }
            label={<StyledListItemText sx={{ fontSize: '14px', fontWeight: 500 }}>{value}</StyledListItemText>}
          />
        ))}
      </div>
    </Popover>
  );
};
